// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.join-room-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.join-room-card {
  background: white;
  border-radius: 12px;
  padding: 40px;
  max-width: 450px;
  width: 100%;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.invitation-icon {
  font-size: 60px;
  margin-bottom: 20px;
}

.error-icon {
  font-size: 60px;
  margin-bottom: 20px;
}

.join-room-card h2 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 24px;
}

.room-preview {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.room-name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.room-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 10px;
}

.invite-role {
  font-size: 14px;
  color: #666;
}

.role-badge {
  background: #e3f2fd;
  color: #1976d2;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
}

.user-info {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
}

.user-info p {
  margin: 0 0 5px 0;
  color: #666;
  font-size: 14px;
}

.user-info strong {
  display: block;
  color: #333;
}

.user-info span {
  color: #999;
  font-size: 12px;
}

.join-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-large {
  padding: 15px 30px;
  font-size: 16px;
}

.auth-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.login-message {
  color: #666;
  margin-bottom: 20px;
}

.loading {
  padding: 40px;
  text-align: center;
  color: #666;
}

.error-message {
  background: #fee;
  color: #c00;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.btn-primary {
  padding: 12px 24px;
  background: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.btn-primary:hover {
  background: #357abd;
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 12px 24px;
  background: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-secondary:hover {
  background: #e5e5e5;
}

.btn-small {
  padding: 6px 12px;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/JoinRoom.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".join-room-page {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  padding: 20px;\r\n}\r\n\r\n.join-room-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 40px;\r\n  max-width: 450px;\r\n  width: 100%;\r\n  text-align: center;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.invitation-icon {\r\n  font-size: 60px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.error-icon {\r\n  font-size: 60px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.join-room-card h2 {\r\n  margin: 0 0 20px 0;\r\n  color: #333;\r\n  font-size: 24px;\r\n}\r\n\r\n.room-preview {\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.room-name {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.room-description {\r\n  color: #666;\r\n  font-size: 14px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.invite-role {\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.role-badge {\r\n  background: #e3f2fd;\r\n  color: #1976d2;\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n.user-info {\r\n  margin-bottom: 20px;\r\n  padding: 15px;\r\n  border: 1px solid #eee;\r\n  border-radius: 8px;\r\n}\r\n\r\n.user-info p {\r\n  margin: 0 0 5px 0;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n.user-info strong {\r\n  display: block;\r\n  color: #333;\r\n}\r\n\r\n.user-info span {\r\n  color: #999;\r\n  font-size: 12px;\r\n}\r\n\r\n.join-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.btn-large {\r\n  padding: 15px 30px;\r\n  font-size: 16px;\r\n}\r\n\r\n.auth-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: center;\r\n}\r\n\r\n.login-message {\r\n  color: #666;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.loading {\r\n  padding: 40px;\r\n  text-align: center;\r\n  color: #666;\r\n}\r\n\r\n.error-message {\r\n  background: #fee;\r\n  color: #c00;\r\n  padding: 10px 15px;\r\n  border-radius: 4px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.btn-primary {\r\n  padding: 12px 24px;\r\n  background: #4a90e2;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: #357abd;\r\n}\r\n\r\n.btn-primary:disabled {\r\n  background: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.btn-secondary {\r\n  padding: 12px 24px;\r\n  background: #f5f5f5;\r\n  color: #333;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: #e5e5e5;\r\n}\r\n\r\n.btn-small {\r\n  padding: 6px 12px;\r\n  font-size: 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
